// BulkDiscountForm.tsx
import { Checkbox, Flex, NumberInput, RadioGroup, Text } from "@chakra-ui/react";
import { Button } from "./ui/button";

type DiscountType = "rate" | "amount";

type BulkDiscountFormProps = {
  // 入力値
  discountType: DiscountType;
  discountRate?: number;
  discountAmount?: number;
  selectedItemIds: string[];

  // イベントハンドラー
  onDiscountTypeChange: (type: DiscountType) => void;
  onDiscountRateChange: (rate?: number) => void;
  onDiscountAmountChange: (amount?: number) => void;
  onSelectAllChange: (selected: boolean) => void;
  onSetDiscount: () => void;

  // 表示制御
  isAllSelected: boolean;
};

export function BulkDiscountForm({
  discountType,
  discountRate,
  discountAmount,
  selectedItemIds,
  onDiscountTypeChange,
  onDiscountRateChange,
  onDiscountAmountChange,
  onSelectAllChange,
  onSetDiscount,
  isAllSelected,
}: BulkDiscountFormProps) {
  return (
    <>
      <Flex gap={2} alignItems="center" justifyContent="flex-end" mt={2} mb={2}>
        <RadioGroup.Root
          value={discountType}
          onValueChange={(details) => onDiscountTypeChange(details.value as DiscountType)}
          display="flex"
          alignItems="center"
          gap={2}
        >
          <RadioGroup.Item value="rate">
            <RadioGroup.ItemHiddenInput value="rate" />
            <RadioGroup.ItemIndicator />
            <RadioGroup.ItemText>率</RadioGroup.ItemText>
          </RadioGroup.Item>
          <RadioGroup.Item value="amount">
            <RadioGroup.ItemHiddenInput value="amount" />
            <RadioGroup.ItemIndicator />
            <RadioGroup.ItemText>金額</RadioGroup.ItemText>
          </RadioGroup.Item>
        </RadioGroup.Root>
        {discountType === "rate" ? (
          <>
            <NumberInput.Root
              maxWidth="70px"
              min={1}
              max={99}
              value={discountRate?.toString()}
              onValueChange={(details) => onDiscountRateChange(details.valueAsNumber || undefined)}
            >
              <NumberInput.Input />
            </NumberInput.Root>
            <Text>%</Text>
          </>
        ) : (
          <>
            <Text>¥</Text>
            <NumberInput.Root
              maxWidth="100px"
              min={1}
              value={discountAmount?.toString()}
              onValueChange={(details) => onDiscountAmountChange(details.valueAsNumber || undefined)}
            >
              <NumberInput.Input />
            </NumberInput.Root>
          </>
        )}
        <Button onClick={onSetDiscount} colorPalette="yellow">
          設定する
        </Button>
      </Flex>
      <Flex gap={2} alignItems="center" mt={2} mb={2}>
        <Checkbox.Root checked={isAllSelected} onCheckedChange={(details) => onSelectAllChange(!!details.checked)}>
          <Checkbox.HiddenInput />
          <Checkbox.Control>
            <Checkbox.Indicator />
          </Checkbox.Control>
          <Checkbox.Label>{isAllSelected ? "すべて解除" : "すべて選択"}</Checkbox.Label>
        </Checkbox.Root>
        <Text fontSize="sm" color="gray.600">
          選択中: {selectedItemIds.length}件
        </Text>
      </Flex>
    </>
  );
}
